import { Card, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useQuery } from '@tanstack/react-query';
import { invitationApi } from 'src/api/invitation';
import { useUserContext } from 'src/auth/useUserContext';
import NotificationsInvitesListTable from 'src/sections/@dashboard/notifications/components/NotificationsInvitesListTable';
import { useOrganizationContext } from 'src/sections/@dashboard/organization/hooks/useOrganizationContext';
import { translateKey } from 'src/locales/translate';


export default function NotificationsTabsInvitesPage() {
  const theme = useTheme();
  const { refetch: refetchUser } = useUserContext();
  const { refetch: refetchOrganizations } = useOrganizationContext();

  const { data, isError, refetch } = useQuery(
    ['invites'],
    () => invitationApi.invitationControllerGetInvitationsByUserId(),
    {
      retry: 2,
    },
  );

  const onFetchInvites = () => {
    refetch();
    refetchUser();
    refetchOrganizations();
  };

  const invites = data?.data || [];

  return (
    <Card
      sx={{
        height: '100%',
        display: 'flex',
        flex: 1,
        boxShadow: theme.customShadows.z24,
      }}
    >
      <Stack sx={{ height: 1, minHeight: '560px', flex: 1 }}>
        <Stack
          sx={{ minHeight: '84px' }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          p={3}
        >
          <Typography variant="h6">{translateKey("hardcoded.zaproszenia_do_placowek")}</Typography>
        </Stack>
        <NotificationsInvitesListTable
          invites={invites}
          isError={isError}
          fetchInvites={onFetchInvites}
        />
      </Stack>
    </Card>
  );
}
